<template>
  <div id="facilitador">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Facilitadores
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.prevent="showDialogFacilitador()">Nuevo</v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="facilitadores"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
            <td>{{ props.item.cargo }}</td>
            <td>{{ props.item.formacion_profesional }}</td>
            <td>{{ props.item.tipo_contrato }}</td>
            <td>
              <v-switch
                color="green lighten-1"
                :label="props.item.es_vigente?'activo':'inactivo'"
                v-model="props.item.es_vigente"
                @change="changeEsVigente(props.item.id, props.item.es_vigente)"
                hide-details
              ></v-switch>
            </td>
            <td >
              <!-- <v-btn
                depressed
                icon
                dark
                color="success"
                small
                @click="editItem(props.item)"
              >
                <v-icon small>edit</v-icon>
              </v-btn> -->
              <v-btn 
                depressed
                icon
                dark
                color="red"
                small
                @click="confirmEliminado(props.item.id)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  <v-dialog v-model="mdialog" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar Facilitador/a</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="formFacilitador">
              <v-layout rows wrap>
                <v-flex xs12 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Nombres"
                    v-model.trim="facilitador.nombre"
                    :rules="[v => !!v || 'El campo es requerido']"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Paterno"
                    v-model.trim="facilitador.paterno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Materno"
                    v-model.trim="facilitador.materno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Cédula de Identidad"
                    v-model.trim="facilitador.cedula_identidad"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3) || 'Mínimo 4 dígitos']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Complemento"
                    v-model.trim="facilitador.complemento"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-select
                    :items="departamentosE"
                    label="Expedido"
                    item-text="sigla"
                    item-value="id"
                    v-model="facilitador.expedido"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-menu
                    v-model="fechaNacPrs"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="facilitador.fecha_nacimiento"
                        label="Fecha de Nacimiento"
                        append-icon="event"
                        :rules="[v => !!v || 'El campo es requerido']"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker locale v-model="facilitador.fecha_nacimiento" @input="fechaNacPrs = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-select
                    :items="generos"
                    label="Genero"
                    item-text="genero"
                    item-value="id"
                    v-model="facilitador.genero_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs6 sm4 class="py-0">
                  <v-select
                    :items="estado_civiles"
                    label="Estado Civil"
                    item-text="estado_civil"
                    item-value="id"
                    v-model="facilitador.estadocivil_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex> -->
                <v-flex xs6 sm4 class="py-0" >
                  <v-select
                    :items="formaciones"
                    label="Formación Profesional"
                    item-text="formacion"
                    item-value="id"
                    v-model="facilitador.formacion_profesional"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm4 class="py-0" >
                  <v-select
                    :items="cargos"
                    label="Cargo"
                    item-text="cargo"
                    item-value="id"
                    v-model="facilitador.cargo"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 class="py-0" >
                  <v-select
                    :items="tipo_contratos"
                    label="Tipo de Contrato"
                    item-text="tipo_contrato"
                    item-value="id"
                    v-model="facilitador.tipo_contrato"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingSegip" color="success darken-1" flat @click="createFacilitador">
            Agregar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mdialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">Esta seguro(a) de eliminar el registro?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="deleteFacilitador()">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
export default {
  name: "facilitador",
  data() {
    return {
      search: "",
      headers: [
        { text: "Nro", align: "left", sortable: false },
        { text: "Nombres y Apellidos ", value: "nombre" },
        { text: "Cargo ", value: "cargo" },
        { text: "Formación Profesional ", value: "formacion_profesional" },
        { text: "Tipo de Contrato ", value: "tipo_contrato" },
        { text: "Estado ", value: "es_vigente" },
        { text: "Acciones", sortable: false, width: "140px" }
      ],
      loading: false,
      loadingSegip: false,
      facilitadores: [],
      facilitador: {
        id: '',
        nombre: '',
        paterno: '',
        materno: '',
        cedula_identidad: '',
        complemento: '',
        expedido: '',
        cargo: '',
        formacion_profesional: '',
        tipo_contrato: '',
        fecha_nacimiento: '',
        genero_tipo_id: '',
        estadocivil_tipo_id: ''
      },
      fechaNacPrs: false,
      tipo_contratos: [],
      departamentosE: [],
      cargos: [],
      formaciones: [],
      generos: [],
      estado_civiles: [],
      mdialog: false,
      mconfirm: false,
      size_width: 0,
      dparams: {},
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      },
      asig: '',
      banderin: []
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    
    if (this.dparams && this.dparams.roluser != Service.rol().director) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getFacilitadores();
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.getWidth);
      this.getWidth();
    });
    this.tipo_contratos = Service.tipoContrato();
  },
  methods: {
    

    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.departamentosE = response.data;
      })
      .catch(error => {
        console.error("Error al cargar datos", error);
      });
    },
    getCargoFormacion() {
      Service.cargoFormacion().then(response => {
        this.cargos = response.data.cargo;
        this.formaciones = response.data.formacion;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getGeneroEstadoCivil() {
      Service.generoEstadoCivil().then(response => {
        this.generos = response.data.genero;
        this.estado_civiles = response.data.estado_civil;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getFacilitadores() {
      this.loading = true;

      axios
        .get(Service.getBase() + 'lista/facilitador/' + this.dparams.ie_id, Service.getHeader())
        .then(response => {
          this.loading = false;
          this.facilitadores = response.data; //console.log(this.facilitadores);
        })
        .catch(error => {
          this.loading = false;
          console.error("Error al cargar registros", error);
        });
    },
    showDialogFacilitador() {
      this.$refs.formFacilitador.reset();
      this.getCargoFormacion();
      this.getGeneroEstadoCivil();
      this.getExpedidos(1);
      this.mdialog = true;
    },
    createFacilitador() {
      if (this.$refs.formFacilitador.validate()) {
        this.facilitador.complemento = this.facilitador.complemento?this.facilitador.complemento:'';
        this.facilitador.institucioneducativa_id = this.dparams.ie_id;
        this.loadingSegip = true;
        if (Service.validateSegip()) {
          Service.postValidarSegip(this.facilitador).then(response => {
            this.loadingSegip = false;
            if (response.data.valido == 1) {
              this.facilitador.segip_id = response.data.valido;
              this.toast('success', response.data.msg);
              this.saveFacilitador(this.facilitador);
            } else {
              this.toast('warning', response.data.msg);
            }
          }).catch(() => {
            this.loadingSegip = false;
          });
        } else {
          this.saveFacilitador(this.facilitador);
        }
      }
    },
    saveFacilitador(facilitador) {
      this.loadingSegip = true;
      axios
        .post(Service.getBase() + "guarda/facilitador", facilitador, Service.getHeader())
        .then(response => {
          this.loadingSegip = false;
          if (response.data.estado == 200) {
            this.getFacilitadores();
            this.$refs.formFacilitador.reset();
            this.mdialog = false;
            this.toast("success", "Registro guardado.");
          } else {
            this.toast("warning", response.data.msg);
          }
        })
        .catch(error => {
          this.loadingSegip = false;
          this.toast("error", "No se pudo guardar");
        });
    },
    changeEsVigente(ttec_dp_id, es_vigente) {
      axios
        .put(Service.getBase() + 'modifica/facilitador/' + ttec_dp_id, {es_vigente: es_vigente}, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro modificado.');
          // this.getFacilitadores();
        })
        .catch(error => {
          console.error('Error al modificar', error);
        });
    },
    confirmEliminado(facilitador_id) {
      this.facilitador.id = facilitador_id;
      this.mconfirm = true;
    },
    deleteFacilitador() {
      axios
        .get(Service.getBase() + "lista/facilitadorasig/" + this.facilitador.id, Service.getHeader())
        .then(response => { 
          
          this.banderin = response.data.yoyo; 

          if(this.banderin.length == 0){
          axios
            .delete(Service.getBase() + 'elimina/facilitador/' + this.facilitador.id, Service.getHeader())
            .then(() => {
              this.toast('success', 'Registro eliminado.');
              this.mconfirm = false;
              this.getFacilitadores();
            })
            .catch(error => {
              console.error('Error al eliminar', error);
            });
          }else{
            this.mconfirm = false;
            this.toast('warning', 'El docente dicta o dictó algun curso, no se puede eliminar.');
          }
          
        });
      
      
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWidth);
    },

    asignado(codigo){ //si el docente esta pasando clases en algun curso en curso no se puede borrar
      axios
        .get(Service.getBase() + "lista/facilitadorasig/" + codigo, Service.getHeader())
        .then(response => { 
          this.banderin = response.data.yoyo; 
        });
    },
  }
};
</script>